import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default function SidebarLink({ icon: Icon, label, link, isActive, onClick, isCompact = false }) {
  return (
    <Link
      to={link}
      onClick={onClick}
      title={isCompact ? label : undefined}
      className={`group flex items-center gap-3 rounded-lg transition-all duration-300 ease-in-out no-underline sidebar-item ${
        isCompact ? 'justify-center p-2' : 'px-2 py-3'
      } ${
        isActive
          ? 'bg-white/20 text-white shadow-lg backdrop-blur-sm'
          : 'text-teal-100 hover:bg-white/10 hover:text-white'
      }`}
    >
      <div
        className={`flex items-center justify-center rounded-md transition-all duration-300 sidebar-icon ${
          isCompact ? 'h-6 w-6' : 'h-7 w-7'
        } ${
          isActive ? 'bg-white/20' : 'bg-white/5 group-hover:bg-white/10'
        }`}
      >
        <Icon size={isCompact ? 16 : 18} />
      </div>
      {!isCompact && <span className="truncate text-sm font-medium transition-all duration-300">{label}</span>}
    </Link>
  );
}

SidebarLink.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  isCompact: PropTypes.bool,
};

SidebarLink.defaultProps = {
  isActive: false,
  isCompact: false,
};
